import { Fragment } from 'react';
import Text from '~/components/typographies/Text';
import { NavigationSidebarSubmenuItem } from '~/layouts/dashboard/navigation/NavigationSidebarSubmenuItem';
import { SubmenuSection } from '~/types/sidebar';
import styles from './NavigationSubmenu.module.scss';

interface Props {
  sections: SubmenuSection[];
}

const NavigationSubmenu: React.FC<Props> = ({ sections }) => {
  return (
    <div className={styles.navigationSubmenu}>
      {sections.map((section) => (
        <Fragment key={section.label || 'submenu'}>
          {section.borderTop && <hr className={styles.divider} />}
          {section.label && (
            <Text variant="caption" weight="medium" secondaryColor className={styles.label}>
              {section.label}
            </Text>
          )}
          {section.items.map(
            ({ action, href, label, icon, notificationCount, notificationTooltip, onClick, matchSubRoutes }) => (
              <NavigationSidebarSubmenuItem
                action={action}
                href={href}
                onClick={onClick}
                key={label}
                label={label}
                Icon={icon}
                notificationCount={notificationCount}
                notificationTooltip={notificationTooltip}
                matchSubRoutes={matchSubRoutes}
              />
            ),
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default NavigationSubmenu;
